module.exports = __webpack_public_path__ + "static/media/Week 2 Sunday.872ad152.png";